import BaseApp from "./BaseApp";
import IntegrationService from './IntegrationService';
import QuitTestButton from "./Screens/QuitTestButton";

export default class IntegrationApp extends BaseApp {
    constructor() {
        super();

        this.integrationService = new IntegrationService(this.dispatcher, this.sessionService, this.proxyRecorder, this.urlHelper,
            this.test, this.webcamAccessManager, this.resultCollector, this.cookieConsentManager, this.messageService, this.uiService, this.errorService,this.faceService,
            this.environment);
    }

    async init() {
        const environmentCheckResult = await this.integrationService.waitForConfig();

        return await super.init(environmentCheckResult, true);
    }

    async run() {
        const sessionCreated = await this.dispatcher.run();
        if (!sessionCreated) {
            const errorScreen = new ErrorScreen(this.uiService);
            errorScreen.display();

            return;
        }

        new QuitTestButton(this.messageService, this.test).init();
    }
}